module.exports = "<home-page></home-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appHome.html
// module id = 1752
// module chunks = 0